import axios from '../common/axios';

export const dispatchShipment = async (payload, single = false) => {
  try {
    const response = await axios.post(
      `/shippings/${single ? 'dispatchOne' : 'dispatchMany'}`,
      payload,
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const readTrackingFromPdf = async file => {
  try {
    const response = await axios.post('/shippings/readTrackingFromPdf', file, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });

    return response.data;
  } catch (error) {
    const message =
      (error.response.data && error.response.data.message) ||
      error.message ||
      'Failed to process PDF.';
    throw new Error(message);
  }
};

export const verifyShipments = async trackingNumbers => {
  try {
    const response = await axios.post(
      '/shippings/verifyShipments',
      trackingNumbers,
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const updateToPaid = async trackingNumbers => {
  try {
    const response = await axios.post(
      '/shippings/updateToPaid',
      trackingNumbers,
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};

export const changeShipmentStatus = async ({ shipmentId, status }) => {
  try {
    const response = await axios.post(
      `/shippings/changeShipmentStatus?_id=${shipmentId}&status=${status}`,
    );
    return response.data;
  } catch (error) {
    return error.response.data;
  }
};
